export { createCache, getValue, isConst } from "@ember/-internals/metal";